import { mapToGoalSummaryLine } from "web_myplann/Goals/Helpers/mapToGoalSummaryLine";
import type { GoalSummarySegmentData } from "web_myplann/Goals/Types/GoalSummary";
import type { GoalSummaryLineInput } from "web_myplann/Goals/Types/GoalSummaryLine";
import { FuturePortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const mapToGoalSummarySegments = (
	goal: GoalSummaryLineInput,
): GoalSummarySegmentData[] => {
	const line = mapToGoalSummaryLine(goal);
	if (!line) return [];

	const segments: GoalSummarySegmentData[] = [
		{ kind: "price", amount: line.price },
	];

	if (!line.withLoanBreakdown) {
		if (line.ownFunds > 0) {
			segments.push({ kind: "ownFunds", amount: line.ownFunds });
		}

		return segments;
	}

	segments.push({
		kind: "mustHave",
		amount: line.mustHave,
		setAsideAmount: line.ownFunds > 0 ? line.ownFunds : undefined,
	});

	if (line.loanAmount > 0) {
		segments.push({
			kind:
				line.loanKind === FuturePortfolioTypeEnum.Mortgage
					? "mortgage"
					: "loan",
			amount: line.loanAmount,
		});
	}

	return segments;
};
